import '~/js/modules/common'
import '~/js/modules/tabs'
import '~/js/modules/simple-dropdown'
import '~/js/modules/products-filter'
import '~/pug/blocks/products-list/products-list'

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import Dropdown from '~/js/modules/dropdown'

const DROPDOWN_IDS = [
  `filters-1`,
  `filters-2`,
  `filters-3`,
  `filters-4`,
  `filters-5`,
  `filters-6`,
  `filters-7`
]

const RANGE_IDS = [
  `filters-7`,
  `filters-8`,
  `filters-9`,
]

const productsFiltersCloseBtnClickHandler = (e) => {
  const productsFilters = e.target.closest(`.js-products-filters`)

  if (productsFilters) {
    clearAllBodyScrollLocks()
    productsFilters.classList.add(`hidden`)
  }

  e.currentTarget.removeEventListener(`click`, productsFiltersCloseBtnClickHandler)
}

document.addEventListener(`DOMContentLoaded`, () => {
  const dropdownInstances = [];
  let dropDownEls;

  dropDownEls = document.querySelectorAll(`div[data-dropdown-id]`);
  dropDownEls.forEach(dropDownEl => new Dropdown('filters-' + dropDownEl.dataset.dropdownId));

  if (DROPDOWN_IDS.length) {
    DROPDOWN_IDS.forEach(id => dropdownInstances.push(new Dropdown(id)))
  }

  const productsFiltersBtn = document.querySelector(`.js-products-filters-btn`)

  if (productsFiltersBtn) {
    const productsFilters = document.querySelector(`.js-products-filters`)

    if (productsFilters) {
      if (window.innerWidth >= 1024) {
        productsFilters.classList.remove(`hidden`)
      } else {
        productsFilters.classList.add(`hidden`)
      }
    }

    productsFiltersBtn.addEventListener(`click`, () => {
      if (productsFilters) {
        disableBodyScroll(productsFilters)
        productsFilters.classList.remove(`hidden`)

        const productsFiltersCloseBtn = productsFilters.querySelector(`.js-products-filters-close`)

        if (productsFiltersCloseBtn) {
          productsFiltersCloseBtn.addEventListener(`click`, productsFiltersCloseBtnClickHandler)
        }
      }
    })

    window.addEventListener(`resize`, () => {
      clearAllBodyScrollLocks()

      if (window.innerWidth >= 1024) {
        productsFilters.classList.remove(`hidden`)
      } else {
        productsFilters.classList.add(`hidden`)
      }
    })
  }

})
